export default __webpack_public_path__ + "media/sm_opportunity2_icon.432f2d8b1e9c49f16277967ce308047f.svg";